import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
const libraryStore = stores.AppStore.projectsLibraryStore;

export class AdditionalProjectDetailsVM {
  @observable props;
  @observable projectId: string;
  @observable elementsVisible: boolean = false;
  @observable projectDetails: any = [];
  constructor(props) {
    this.props = props;
    this.projectId = this.props.projectId;
  }
  @observable editedProjectDetails: any = {
    practice: '',
    location: '',
    description: '',
  };

  @action.bound toggleElementsVisible() {
    this.elementsVisible = !this.elementsVisible;
  }

  @action.bound async handleEdit() {
    this.toggleElementsVisible();
  }

  @action.bound async cancelEdit() {
    this.toggleElementsVisible();
    this.getAdditionalProjectDetails(this.projectDetails);
  }

  @action.bound handleInputChange(event) {
    event.preventDefault();
    const { name, value } = event.target;
    this.editedProjectDetails[name] = value;
    if(this.projectDetails.practice?.length && name !=='practice'){
      this.editedProjectDetails.practice = this.projectDetails.practice
    }
    if(this.projectDetails.location?.length && name !=='location'){
      this.editedProjectDetails.location = this.projectDetails.location
    }
    if(this.projectDetails.description?.length && name !=='description'){
      this.editedProjectDetails.description = this.projectDetails.description
    }
    this.projectDetails = { ...this.editedProjectDetails };
  
  }

  @action.bound async getAdditionalProjectDetails(projectId) {
    libraryStore.incrementLoading();

    try {
      const response = await PRJAPI.ProjectDetails.getAdditionalProjectDetailsByProjectUuidUsingGET(this.projectId);
      this.projectDetails = response.data;
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      libraryStore.decrementLoading();
    }
  }

  @action.bound async editAdditionalProjectDetails() {
    const postJSON = {
      projectUuid: this.projectId,
      practice: this.projectDetails.practice,
      location: this.projectDetails.location,
      description: this.projectDetails.description,
      status: 'update',
    };

    try {
      await PRJAPI.ProjectDetails.editAdditionalProjectDetailsByProjectUuidUsingPOST(postJSON);
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
    this.getAdditionalProjectDetails(this.projectId);
    this.elementsVisible = !this.elementsVisible;
  }
}
